import { application } from '../application'

import HeaderController from "./header_controller"
import ScheduleController from "./schedule_controller"
import SeanceController from "./seance_controller"
import TaskController from "./task_controller"
import ProfileFormController from "./profile_form_controller"

application.register("header", HeaderController)
application.register("schedule", ScheduleController)
application.register("seance", SeanceController)
application.register("task", TaskController)
application.register("profile-form", ProfileFormController)
